import React from 'react'
import styled from 'styled-components'

import { CHAPTER_VIEW_BAR_TOP_OFFSET, CHAPTER_VIEW_PROGRESS_BAR_HEIGHT } from '../constants'

const DASH_LINE_COLOR = '#C5C6C8'

type ChapterViewDashedLinesProps = {
  topOffset?: number
}

const ChapterViewDashedLines = ({
  topOffset = CHAPTER_VIEW_BAR_TOP_OFFSET
}: ChapterViewDashedLinesProps): JSX.Element => (
  <Container $topOffset={topOffset}>
    <Line />
    <Line />
    <Line />
    <Line />
    <Line />
  </Container>
)

export default ChapterViewDashedLines

const Container = styled.div<{ $topOffset: number }>`
  height: ${CHAPTER_VIEW_PROGRESS_BAR_HEIGHT}px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  position: absolute;
  left: 0;
  top: ${({ $topOffset }) => $topOffset}px;
  pointer-events: none;
  opacity: 0.5;
  z-index: 0;
`

const Line = styled.div`
  width: 100%;
  height: 1px;
  border-bottom: 1px dashed ${DASH_LINE_COLOR};
`
